module.exports = __webpack_public_path__ + "img/04.a471e186.png";